import React from "react";

function SectionWhoCanBenefit() {
  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* Title section */}
      <div className="justify-content-center text-center">
        {/* Advantages of Humanizing Text */}
        <h1 className="display-6">
          Who would benefit from using an AI humanizer?
        </h1>
      </div>

      {/* Description section */}
      <div>
        <h5 className="mt-4">Content Creators & Bloggers:</h5>
        <p className="lead">
          To give readers of AI-generated content a more engaging, organic, and
          personal experience.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Marketers & Copywriters:</h5>
        <p className="lead">
          For creating relatable, compelling content that increases conversions
          and establishes a stronger connection with target audiences.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Students & Academics:</h5>
        <p className="lead">
          To improve AI-assisted writing for research, essays, and assignments
          so that it sounds less robotic and more real.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Businesses & Brands:</h5>
        <p className="lead">
          For producing human-like emails, social media posts, and consumer
          correspondence that fosters brand loyalty and trust.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Freelancers & Agencies:</h5>
        <p className="lead">
          To expedite their writing process while maintaining high-quality,
          customised output for customers.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Non-native English Speakers:</h5>
        <p className="lead">
          To make content produced by AI sound like it was written by a native
          speaker by polishing it into fluid, natural English.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Social Media Influencers:</h5>
        <p className="lead">
          To add a human touch to posts and captions in order to increase
          interaction and strengthen the voice of your personal brand.
        </p>
      </div>

      <div>
        <h5 className="mt-4">Job Seekers & Professionals:</h5>
        <p className="lead">
          To give the impression that AI-generated cover letters, resumes, and
          LinkedIn profiles are authentic and customised.
        </p>
      </div>
    </div>
  );
}

export default SectionWhoCanBenefit;
